import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import {
  back_button,
  aplicantList,
  mainApllicant,
  addedDocContaoner,
  scrollbar_none
} from './RequestDocument.module.css';
import Modal from '../../../common/components/Modal/modal';
const mainApplicant = '/images/icons/applicant.svg';
const otherAppplicant = '/images/icons/user.svg';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import PopUp from '../../../common/components/PopUp/PopUp';
import ViewRequestedDocs from './ViewRequestedDocs';
const commonInputEffect = { height: '52px', maxWidth: '100%' };

const RequestDocument = () => {
  const [type, setType] = useState('success');
  const [text, setText] = useState('Document Requested Successfully!');
  const [show, setShow] = useState(false);
  const [goto, setGoto] = useState('');
  const [docRequiredPopUp, setDocRequiredPopUp] = useState(false);

  const arowAdjactmentStyle = {
    paddingLeft: '2px',
    marginTop: '-2px'
  };

  return (
    <React.Fragment>
      <Helmet title={`Request Documents | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd max-screen flex-1  w-full ">
            <Header />

            <div className="w-full px-3  ">
              <div className="w-full my-4 bg-white h-full px-3 py-4 rounded  ">
                <div className="flex">
                  <div className={`${back_button} mr-2 cursor-pointer`}>
                    <div className="" style={arowAdjactmentStyle}>
                      <ArrowBackIosRoundedIcon
                        style={{ fontSize: '15px', color: '#00000045' }}
                      />
                    </div>
                  </div>
                  <div className="">
                    <p className="font-roboto font-medium text-base text-black-1015 ">
                      Requested Documents
                    </p>
                    <p className="font-roboto font-normal text-xs text-grey-1005">
                      you can click on the card to know the details
                    </p>
                  </div>
                  <div className="float-right ml-auto mr-3">
                    <button
                      className="px-3 py-3 text-white font-roboto font-normal bg-green-1000 rounded "
                      type="button"
                      onClick={e => setDocRequiredPopUp(true)}
                    >
                      Request Documents
                    </button>
                  </div>
                </div>
                <ViewRequestedDocs />
              </div>
            </div>
          </div>
        </div>

        {docRequiredPopUp ? (
          <ModalViewForAddDocReq
            setDocRequiredPopUp={setDocRequiredPopUp}
            popUpsetShow={setShow}
          />
        ) : null}
        <PopUp
          type={type}
          text={text}
          setShow={setShow}
          show={show}
          goto={goto}
        />
      </div>
    </React.Fragment>
  );
};

export default RequestDocument;

const ModalViewForAddDocReq = ({ setDocRequiredPopUp, popUpsetShow }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!show) setDocRequiredPopUp(false);
  }, [show]);

  const modalContainer = {
    width: '50%',
    maxWidth: '600px',
    overflow: 'auto',
    minWidth: '400px'
  };
  const dummyApplicants = [
    {
      isMainApplicant: true,
      applicant_type: 'Appicant'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    }
  ];
  return (
    <Formik
      initialValues={{
        add_new_doc: '',
        doc_list: []
      }}
      validationSchema={yup.object().required('required')}
    >
      {({
        setFieldValue,
        touched,
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldTouched
      }) => {
        const formikFunctions = {
          setFieldValue: setFieldValue,
          touched: touched,
          errors: errors,
          values: values,
          handleChange: handleChange,
          handleBlur: handleBlur,
          handleSubmit: handleSubmit,
          setFieldTouched: setFieldTouched
        };
        return (
          <Form className={`w-full`}>
            <div className="">
              <Modal
                show={show}
                setShow={setShow}
                styleContainer={modalContainer}
                title="Request Documents"
              >
                <div
                  className={` text-grey-920 text-base font-roboto font-medium`}
                >
                  <hr className="mb-5" style={{ color: '#e4e4e4' }} />
                  <h3 className="w-full text-black-1010 font-roboto font-medium text-sm mb-4">
                    Whose Documents Needed ?
                  </h3>
                  <div className="w-ful flex overflow-auto">
                    {dummyApplicants.map((each, index) => (
                      <ListOfApplicants
                        key={index}
                        isMainApplicant={each.isMainApplicant}
                        applicant_type={each.applicant_type}
                      />
                    ))}
                  </div>
                  <div className="w-full py-5">
                    <AddNewDocument formikFunctions={formikFunctions} />
                  </div>
                  <div
                    className={`w-full overflow-auto ${addedDocContaoner} ${scrollbar_none}`}
                  >
                    <ShowAddedDocument formikFunctions={formikFunctions} />
                  </div>
                  <div className="w-full">
                    <button
                      type="button"
                      className="submitButton font-roboto text-white text-base w-48 "
                      onClick={() => {
                        setShow(false), popUpsetShow(true);
                      }}
                    >
                      SEND REQUEST
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

const ListOfApplicants = ({ isMainApplicant, applicant_type }) => {
  return (
    <div
      className={`block ${
        isMainApplicant ? mainApllicant : aplicantList
      } items-center text-center `}
    >
      <img
        src={isMainApplicant ? mainApplicant : otherAppplicant}
        className="w-12 h-10 rounded mx-auto"
      />
      <p className="font-roboto text-center font-normal text-black-500 text-xs my-1">
        {applicant_type}
      </p>
    </div>
  );
};

const AddNewDocument = ({ formikFunctions }) => {
  const handleCommonFunction = name => {
    return {
      onChange: formikFunctions?.handleChange,
      onBlur: formikFunctions?.handleBlur,
      value: formikFunctions?.values[name?.toString()],
      error:
        formikFunctions?.touched[name.toString()] &&
        formikFunctions?.errors[name.toString()],
      stylesContainer: commonInputEffect,

      errorMsg: formikFunctions?.errors[name.toString()],
      touched: formikFunctions?.touched[name.toString()]
    };
  };
  const addnewDoc = async () => {
    if (!formikFunctions?.values?.add_new_doc) return;
    let preValues = formikFunctions.values.doc_list || [];
    let curr_value = {
      name: formikFunctions?.values?.add_new_doc,
      id: formikFunctions?.values?.doc_list.length + 1
    };
    await preValues.push(curr_value);
    formikFunctions.setFieldValue('doc_list', preValues);
    formikFunctions.setFieldValue('add_new_doc', '');
  };

  return (
    <div className="w-full flex">
      <div className="w-6/12">
        <CommonInput
          name="add_new_doc"
          placeholder="Enter Documment Name"
          {...handleCommonFunction('add_new_doc')}
        />
      </div>

      <div
        className="bg-orange-1000 rounded px-4 py-2 mx-3 items-center pt-3 cursor-pointer"
        style={{ backgroundColor: '#ffb11459' }}
        onClick={addnewDoc}
      >
        <AddCircleOutlineIcon style={{ color: '#FF8000', width: '30px' }} />
      </div>
    </div>
  );
};

const ShowAddedDocument = ({ formikFunctions }) => {
  let docList = formikFunctions?.values?.doc_list;

  const deleteAddedItem = async id => {
    const newList = [];
    for (let i = 0; i < docList.length; i++) {
      if (docList[i].id == id) continue;
      newList.push(docList[i]);
    }
    formikFunctions.setFieldValue('doc_list', newList);
  };
  return (
    <list className="w-full block items-center">
      {docList.map((each, index) => (
        <ul
          className="w-full font-roboto font-medium text-sm text-black-500 mx-1 my-2 flex"
          key={index}
        >
          <span className="">{index + 1}.</span> {each.name}
          <div
            className="mx-1 cursor-pointer "
            style={{ marginTop: '-2px' }}
            onClick={() => deleteAddedItem(each.id)}
          >
            <CancelOutlinedIcon style={{ color: '#48545E', width: '15px' }} />
          </div>
        </ul>
      ))}
    </list>
  );
};
